import {
  StockFilterByDate,
  StockGroupReportBy,
} from '@/core/domain/reports/stock/DeliveryOfmaterial/DeliveryOfmaterial.types';
import { Col, Form, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';

const DeliveryOfMaterialOptionsEmployessVsInputs = () => {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;

  return (
    <Row>
      <Col xs={24}>
        <Title level={5}>
          {intl({
            id: 'stock.DeliveryOdMaterial.form.selectReportType',
          })}
        </Title>
        <Form.Item
          name="employeePerConsumableReportType"
          initialValue={StockFilterByDate.closing}
        >
          <Radio.Group optionType="button" buttonStyle="solid" size="large">
            <Radio value={StockFilterByDate.closing}>
              {intl({
                id: 'stock.DeliveryOdMaterial.form.selectReportType.closing',
              })}
            </Radio>
            <Radio value={StockFilterByDate.deliveryReturn}>
              {intl({
                id: 'stock.DeliveryOdMaterial.form.selectReportType.deliveryReturn',
              })}
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Title level={5}>
          {intl({
            id: 'stock.DeliveryOdMaterial.form.stockGroupReportBy',
          })}
        </Title>
        <Form.Item
          name="employeePerConsumableGroupBy"
          initialValue={StockGroupReportBy.date}
        >
          <Radio.Group optionType="button" buttonStyle="solid" size="large">
            <Radio value={StockGroupReportBy.date}>
              {intl({
                id: 'stock.DeliveryOdMaterial.form.stockGroupReportBy.date',
              })}
            </Radio>
            <Radio value={StockGroupReportBy.employee}>
              {intl({
                id: 'stock.DeliveryOdMaterial.form.stockGroupReportBy.employee',
              })}
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default DeliveryOfMaterialOptionsEmployessVsInputs;
